import { jsx, jsxs } from 'react/jsx-runtime';

const PowerIcon = ({ className, width = 24, height = 24 }) => {
  return /* @__PURE__ */ jsx("span", { className, children: width === 16 ? /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.5923 2.875C10.7386 2.65055 11.0396 2.58692 11.2642 2.73307C12.3455 3.43685 13.1707 4.47151 13.6164 5.68229C14.062 6.89301 14.1045 8.21565 13.7375 9.45247C13.3705 10.6893 12.6132 11.7745 11.5793 12.5462C10.5453 13.3179 9.28942 13.735 7.99922 13.735C6.70898 13.735 5.45315 13.3179 4.41914 12.5462C3.3852 11.7745 2.62799 10.6894 2.26094 9.45247C1.89394 8.21563 1.93642 6.89304 2.38203 5.68229C2.82772 4.47155 3.65293 3.43683 4.73425 2.73307C4.95883 2.58703 5.25993 2.6505 5.40612 2.875C5.55229 3.09958 5.48805 3.40064 5.26354 3.54688C4.35772 4.13649 3.66688 5.0033 3.29349 6.01758C2.9201 7.03202 2.88442 8.14011 3.19193 9.17643C3.49948 10.2127 4.13362 11.1217 4.99987 11.7682C5.8662 12.4148 6.91821 12.7643 7.99922 12.7643C9.08019 12.7643 10.1323 12.4148 10.9986 11.7682C11.8647 11.1217 12.499 10.2126 12.8065 9.17643C13.114 8.14014 13.0783 7.032 12.705 6.01758C12.3316 5.00327 11.6407 4.13651 10.7349 3.54688C10.5103 3.40068 10.4461 3.09964 10.5923 2.875Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M7.99857 2.26562C8.26646 2.26569 8.48348 2.48277 8.4836 2.75065V7.50065C8.4836 7.76863 8.26654 7.98562 7.99857 7.98568C7.73055 7.98568 7.51355 7.76867 7.51355 7.50065V2.75065C7.51366 2.48273 7.73062 2.26562 7.99857 2.26562Z",
            fill: "black"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 24 24",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.8895 4.3125C16.1088 3.97582 16.5604 3.88038 16.8973 4.09961C18.5193 5.15528 19.7571 6.70727 20.4256 8.52344C21.094 10.3395 21.1577 12.3235 20.6072 14.1787C20.0567 16.0339 18.9207 17.6618 17.3699 18.8193C15.819 19.9769 13.9351 20.6025 11.9998 20.6025C10.0645 20.6025 8.18069 19.9769 6.62969 18.8193C5.07877 17.6617 3.94296 16.034 3.39239 14.1787C2.84189 12.3234 2.90561 10.3396 3.57403 8.52344C4.24255 6.70733 5.48037 5.15525 7.10235 4.09961C7.43922 3.88055 7.89088 3.97575 8.11016 4.3125C8.32941 4.64937 8.23305 5.10096 7.89629 5.32031C6.53755 6.20474 5.50129 7.50495 4.94122 9.02637C4.38113 10.548 4.32761 12.2102 4.78887 13.7646C5.2502 15.319 6.20141 16.6825 7.50079 17.6523C8.80027 18.6222 10.3783 19.1465 11.9998 19.1465C13.6213 19.1464 15.1994 18.6222 16.4988 17.6523C17.7981 16.6825 18.7495 15.3189 19.2107 13.7646C19.672 12.2102 19.6185 10.548 19.0584 9.02637C18.4983 7.50491 17.4621 6.20477 16.1033 5.32031C15.7664 5.10101 15.6702 4.64945 15.8895 4.3125Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.9988 3.39844C12.4007 3.39853 12.7262 3.72416 12.7264 4.12598V11.251C12.7264 11.653 12.4008 11.9784 11.9988 11.9785C11.5968 11.9785 11.2713 11.653 11.2713 11.251V4.12598C11.2715 3.7241 11.5969 3.39844 11.9988 3.39844Z",
            fill: "black"
          }
        )
      ]
    }
  ) });
};

export { PowerIcon };
